<template>
  <div id="transhipments">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" class="pt-5 mt-1">
      <div class="d-flex justify-space-between px-5 align-center mb-3">
        <h1>Gerenciamento de Transbordos</h1>
      </div>

      <v-expansion-panels class="px-5 py-1" accordion>
        <v-expansion-panel class="elevation-1">
          <v-expansion-panel-header color="#f2f2f2" class="px-4">
            <span>Filtrar por</span>
            <template v-slot:actions>
              <v-icon color="black"> mdi-chevron-down </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="mt-2">
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateStartMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedStartDate"
                      label="Data Inicial"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" no-title @input="dateStartMenu = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateEndtMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedEndDate"
                      label="Data Final"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="endDate" no-title @input="dateEndtMenu = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="px-5 mb-6 mt-5">
        <transhipment-cards :isLoading="isDashboardLoading" :cardsData="dashboardCardsData" />
      </div>

      <div class="px-5">
        <transhipment-bar-chart :isLoading="isDashboardLoading" :transhipments="dashboardTranshipments" />
      </div>

      <v-row class="ma-2">
        <v-col cols="12" lg="6">
          <transhipment-quantity-bar-chart :date="filterDateObject" />
        </v-col>
        <v-col cols="12" lg="6">
          <transhipment-financial-bar-chart :date="filterDateObject" />
        </v-col>
      </v-row>

      <div class="d-flex justify-space-between px-5 align-center mt-12">
        <h1>Lista de transbordos</h1>
        <router-link to="/transhipments/new">
          <v-btn elevation="2" color="success" large>NOVO TRANSBORDO</v-btn>
        </router-link>
      </div>

      <div class="table mt-10">
        <v-data-table
          :headers="headers"
          :items="desserts"
          :loading="loading"
          :items-per-page="paginate.pageSize"
          @update:items-per-page="changeItemsPerPage"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 50],
            itemsPerPageText: 'Itens por página'
          }"
        >
          <template v-slot:[`item.isCompany`]="{ item }">
            <v-chip v-if="item.isCompany" color="success"> Empresa </v-chip>
            <v-chip v-else color="info"> Pessoal </v-chip>
          </template>

          <template v-slot:[`item.disabled`]="{ item, index }">
            <v-switch
              v-model="item.disabled"
              :false-value="true"
              :true-value="false"
              inset
              color="success"
              readonly
              @click.stop.prevent="openDialogStatus(item, index)"
            ></v-switch>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex align-center">
              <router-link
                class="pr-3"
                :to="`/transhipments/${item.id}/${item.isCompany ? 1 : 0}`"
                :isCompany="item.isCompany"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <PencilSVG v-bind="attrs" v-on="on" />
                  </template>
                  <span>Editar</span>
                </v-tooltip>
              </router-link>
              <router-link class="pr-2" :to="`/transhipments/${item.id}/${item.isCompany ? 1 : 0}/details`">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <ViewSVG v-bind="attrs" v-on="on" />
                  </template>
                  <span>Detalhes</span>
                </v-tooltip>
              </router-link>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <TrashSVG
                    class="ml-1"
                    role="button"
                    @click.stop.prevent="openDialogTrash(item)"
                    title="Deletar"
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <span>Deletar</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <v-pagination v-model="page" :length="paginate.totalPages" :total-visible="7"></v-pagination>
      </div>
    </v-card>

    <v-dialog v-model="dialogStatus" persistent max-width="450">
      <v-card class="align-center text-center">
        <v-card-title class="headline justify-center"> Mudar status do transbordo? </v-card-title>
        <v-card-text>
          Você confirma estar mudando o status do transbordo
          {{ statusItem.name }}
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" @click="dialogStatus = false"> Cancelar </v-btn>
          <v-btn color="success" class="flex-grow-1" @click="toggleItem()"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTrash" persistent max-width="450">
      <v-card class="align-center text-center">
        <v-card-title class="headline justify-center"> Deletar transbordo? </v-card-title>
        <v-card-text>
          Você confirma estar deletando o transbordo
          {{ trashItem.name }}
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" @click="dialogTrash = false"> Cancelar </v-btn>
          <v-btn color="success" class="flex-grow-1" @click="deleteItem()"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MessagesError :errors="errors" @closeMessages="errors = []" :type="errorsType" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import BreadCrumb from '../../../components/BreadCrumb.vue';
import TranshipmentCards from '../../../components/Transhipment/TranshipmentCards.vue';
import TranshipmentBarChart from '../../../components/Transhipment/TranshipmentBarChart.vue';
import TranshipmentQuantityBarChart from '../../../components/Transhipment/TranshipmentQuantityBarChart.vue';
import TranshipmentFinancialBarChart from '../../../components/Transhipment/TranshipmentFinancialBarChart.vue';
import MessagesError from '@/components/MessagesError.vue';
import { FeedbackMessageHandler } from '@/store/modules/feedbackMessageHandler';

// SVGs
import PencilSVG from '../../../assets/img/pencil.svg';
import TrashSVG from '../../../assets/img/trash.svg';
import ViewSVG from '../../../assets/img/view.svg';

export default {
  name: 'Users',
  components: {
    BreadCrumb,
    PencilSVG,
    TrashSVG,
    ViewSVG,
    TranshipmentCards,
    TranshipmentBarChart,
    TranshipmentFinancialBarChart,
    TranshipmentQuantityBarChart,
    MessagesError
  },
  data: () => ({
    errors: [],
    errorsType: 'success',
    dateStartMenu: false,
    dateEndtMenu: false,
    startDate: '',
    endDate: '',
    isDashboardLoading: true,
    dashboardCardsData: {
      onTime: null,
      late: null,
      openLate: null,
      openOnTime: null
    },
    dashboardTranshipments: [],
    dialogTrash: false,
    trashItem: {},
    dialogStatus: false,
    statusItem: {},
    loading: true,

    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Transbordos',
        disabled: true,
        to: '/transhipment'
      }
    ],
    headers: [
      { text: 'NOME', value: 'name', align: 'start' },
      { text: 'CIDADE', value: 'city' },
      { text: 'TIPO DE TRANSBORDO', value: 'isCompany' },
      { text: 'STATUS', value: 'disabled' },
      { text: 'AÇÕES', value: 'actions' }
    ]
  }),
  computed: {
    ...mapState('TranshipmentStore', ['paginate']),
    ...mapGetters('TranshipmentStore', ['getTranshipments']),
    page: {
      get() {
        return this.paginate.pageNumber;
      },
      set(value) {
        this.setPageNumber(value);

        this.fetchAllTranshipment();
      }
    },
    formattedStartDate() {
      if (!this.startDate) return '';
      const [year, month, day] = this.startDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedEndDate() {
      if (!this.endDate) return '';
      const [year, month, day] = this.endDate.split('-');
      return `${day}/${month}/${year}`;
    },
    desserts() {
      return this.getTranshipments;
    },

    filterDateObject() {
      return this.startDate !== '' && this.endDate !== '' ? { startDate: this.startDate, endDate: this.endDate } : null;
    },

    getTheLastThirtyDays() {
      const now = new Date();
      const currentDay = now;
      const thirtyDayAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);

      return {
        thirtyDayAgo: thirtyDayAgo.toISOString().slice(0, 10),
        currentDay: currentDay.toISOString().slice(0, 10)
      };
    }
  },

  watch: {
    startDate: {
      handler() {
        if (this.endDate) this.fetchTranshipmentsDashboardData({ startDate: this.startDate, endDate: this.endDate });
      }
    },
    endDate: {
      handler() {
        if (this.startDate) this.fetchTranshipmentsDashboardData({ startDate: this.startDate, endDate: this.endDate });
      }
    }
  },

  created() {
    this.setItemPerPage(10);
    this.fetchTranshipmentsDashboardData();
    this.handleFeedback();
  },

  mounted() {
    this.filterTheLastThirtyDays();
    this.fetchAllTranshipment();
  },
  methods: {
    ...mapMutations('TranshipmentStore', [
      'setPageNumber',
      'setItemPerPage',
      'trashTranshipment',
      'toggleDisableTranshipment'
    ]),

    ...mapActions('TranshipmentStore', [
      'fetchTranshipment',
      'deleteTranshipment',
      'toggleTranshipment',
      'getTranshipmentsDashboardData'
    ]),

    handleFeedback() {
      const message = FeedbackMessageHandler.getFeedbackMessage(this);
      if (message) {
        this.errorsType = 'success';
        this.errors = [message];
        FeedbackMessageHandler.resetFeedbackMessage(this);
      }
    },

    async fetchTranshipmentsDashboardData(params = { startDate: '', endDate: '' }) {
      try {
        this.isDashboardLoading = true;
        console.log;
        const { onTime, late, openLate, openOnTime, getCountNfesByTranshipmentDto } =
          await this.getTranshipmentsDashboardData(params);
        this.dashboardCardsData = { onTime, late, openLate, openOnTime };
        this.dashboardTranshipments = getCountNfesByTranshipmentDto;
      } catch (error) {
        console.error(error);
      } finally {
        this.isDashboardLoading = false;
      }
    },

    filterTheLastThirtyDays() {
      const { thirtyDayAgo, currentDay } = this.getTheLastThirtyDays;
      this.startDate = thirtyDayAgo;
      this.endDate = currentDay;
    },

    async fetchAllTranshipment() {
      this.loading = true;
      try {
        await this.fetchTranshipment();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    changeItemsPerPage(items) {
      this.setItemPerPage(items);

      this.fetchAllTranshipment();
    },
    async deleteItem() {
      this.loading = true;

      try {
        const { success, errors } = await this.deleteTranshipment(this.trashItem.id);
        console.log(success,errors);
        if (success) {
          this.trashTranshipment(this.trashItem.id);
          this.fetchAllTranshipment();
          this.errors = ['Transbordo deletado com sucesso!'];
          this.errorsType = 'success';
        } else {
          this.errors = errors;
          this.errorsType = 'error';
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
        this.dialogTrash = false;
      }
    },
    openDialogTrash(item, index) {
      this.dialogTrash = true;
      this.trashItem = {
        ...item,
        index
      };
    },
    openDialogStatus(item, index) {
      this.dialogStatus = true;
      this.statusItem = {
        ...item,
        index
      };
    },
    async toggleItem() {
      this.loading = true;

      try {
        await this.toggleTranshipment(this.statusItem);

        this.toggleDisableTranshipment(this.statusItem);
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
        this.dialogStatus = false;
      }
    }
  }
};
</script>

<style lang="scss">
#transhipments {
}
</style>
